import React, { Component } from "react";
import "./SubscriptionPage.scss";
import { connect } from "react-redux";
import { fetchPackageDetails, getStripeURL } from "../../actions/subscriptionAction";
import { ReactComponent as ErrorIcon } from "../SubscriptionModule/BillingComponents/payment-failed.svg";

class SubscriptionPageError extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        // this.props.fetchPackageDetails();
    }

    tryAgain = () => {
        this.props.history.replace("/subscription");
    };

    render() {
        return (
            <div className="subscription-page subscription-error">
                <ErrorIcon />
                {this.props.packageObj.is_trial_used ? <p>Subscription failed</p> : <p>Trial setup failed</p>}
                <button className="submitButton" onClick={this.tryAgain}>
                    Try Again
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    packages: state.subscriptionReducer.packages,
    packageObj: state.globalReducer.packageObj,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPackageDetails: () => dispatch(fetchPackageDetails()),
    getStripeURL: (data) => dispatch(getStripeURL(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPageError);
